import { createTheme } from '@mui/material/styles';

const customTheme = createTheme({
  palette: {
    primary: {
      main: '#007720',
    },
    secondary: {
      main: '#ffa500',
    },
  },
});
export default (customTheme);
